@if (variantId && labelTranslationKey !== '') {
  <div class="widget-demo-chip-wrapper" data-cy="widget-demo-chip">
    <div
      class="widget-demo-chip"
      [ngClass]="{
        'tag-secondary': statusDemo === 'secondary',
        'tag-warning': statusDemo === 'warning',
        'tag-neutral': statusDemo === 'neutral',
      }"
    >
      <label data-cy="widget-demo-chip-label">{{
        labelTranslationKey | transloco: { daysLeft: daysRemaining }
      }}</label>
    </div>
    @if (
      isFurtherQualificationEligible && statusDemo === 'neutral' && !isOrgAdmin
    ) {
      <markant-platform-organization-complete-profile-button
        [variantId]="variantId"
        [isFurtherQualificationProcessInProgress]="
          isFurtherQualificationProcessInProgress
        "
      />
    }
    @if (statusDemo === 'neutral' && isOrgAdmin) {
      <markant-button
        data-cy="to-order-button"
        (click)="goToServiceCatalog()"
        color-scheme="primary"
        variant="clear"
      >
        {{ 'catalog.detail.cartridgeVariants.demo.toOrder' | transloco }}
      </markant-button>
    }
  </div>
}
